import { render, staticRenderFns } from "./PaymentReceipt.vue?vue&type=template&id=023827fc&scoped=true"
import script from "./PaymentReceipt.vue?vue&type=script&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceipt.vue?vue&type=style&index=0&id=023827fc&prod&lang=scss&scoped=true"
import style1 from "./PaymentReceipt.vue?vue&type=style&index=1&id=023827fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023827fc",
  null
  
)

export default component.exports